

export enum KalturaEntryStatus {
    blocked = '6',
	deleted = '3',
	errorConverting = '-1',
	errorImporting = '-2',
	import = '0',
	infected = 'virusScan.Infected',
	moderate = '5',
	noContent = '7',
	pending = '4',
	preconvert = '1',
	ready = '2',
	scanFailure = 'virusScan.ScanFailure'
}